import { render, staticRenderFns } from "./VolunteerSchedule.vue?vue&type=template&id=518cd134&scoped=true"
import script from "./VolunteerSchedule.vue?vue&type=script&lang=js"
export * from "./VolunteerSchedule.vue?vue&type=script&lang=js"
import style0 from "./VolunteerSchedule.vue?vue&type=style&index=0&id=518cd134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518cd134",
  null
  
)

export default component.exports